//export const apiHost = (process.env.NODE_ENV === 'production')
    //? 'https://api.medwagmexico.com'    //server
    //: 'http://192.168.1.70/medwag-crm-php/public'       //local
    //: 'http://localhost/medwag-crm-php/public'       //local
    //: 'https://api.medwagmexico.com'       //local

//export const apiHost = 'https://betamedwag.bluestudio.mx'
export const apiHost = 'https://api.medwagmexico.com'
//export const apiHost = 'http://44.209.26.235/api/public'